module.exports = __webpack_public_path__ + "static/media/CC20-AP200-12.57f2d249.png";